export default "__VITE_ASSET__DJ56Y7u8__"